import { ExibirRastreaveisUsuarioCliente } from './exibirRastreaveisUsuarioCliente';
import { AtualizarUsuarioCliente } from './atualizarUsuarioCliente';
import { DeletarUsuarioCliente } from './deletarUsuarioCliente';
import { ListarUsuariosCliente } from './listarUsuariosCliente';
import { CriarUsuarioCliente } from './criarUsuarioCliente';

(new ExibirRastreaveisUsuarioCliente()).executar();
(new AtualizarUsuarioCliente()).executar();
(new DeletarUsuarioCliente()).executar();
(new ListarUsuariosCliente()).executar();
(new CriarUsuarioCliente()).executar();
